import ChevronRight from '@/assets/icons/ChevronRight.svg';
import { Link } from '@/components/Link';
import type { BreadCrumbLink } from '@/types';
import * as Styled from './Breadcrumb.styled';

interface BreadcrumbProps {
  backLink?: string;
  breadcrumbLinks: BreadCrumbLink[];
}

export const Breadcrumb = ({ backLink, breadcrumbLinks }: BreadcrumbProps) => (
  <Styled.Wrapper>
    {backLink ? (
      <>
        <Styled.BackLink className="back-link" href={backLink}>
          Back
        </Styled.BackLink>
        <Styled.Separator>|</Styled.Separator>
      </>
    ) : null}
    <Styled.Crumbs>
      {breadcrumbLinks.map(({ href, label, selected }) => (
        <Styled.Crumb key={label}>
          {href && !selected ? (
            <>
              <Link href={href}>{label}</Link>
              <ChevronRight />
            </>
          ) : (
            label
          )}
        </Styled.Crumb>
      ))}
    </Styled.Crumbs>
  </Styled.Wrapper>
);
